<template>
    <div class="team-marquee" :class="{ 'team-marquee-dark': dark }" v-if="teams.length > 0">
        <div class="team-marquee-track">
            <!-- Content duplicated so the CSS animation can loop seamlessly
                 (scroll exactly -50%, then jump back unnoticed) instead of
                 leaving a visible gap at the end of one pass. -->
            <span class="team-marquee-item" v-for="(team, idx) in teams.concat(teams)" :key="idx">
                <span class="team-marquee-dot" :style="{ backgroundColor: team.color }"></span>
                {{ team.username }}
            </span>
        </div>
    </div>
</template>

<script>
// Generic "who's already here" ticker - takes a plain {username, color}[]
// list, knows nothing about jerseys/avatars specifically.
export default {
    name: 'TeamMarquee',
    props: {
        teams: {
            type: Array,
            required: true,
        },
        // Text is a muted dark grey by default (fine on the light cards
        // this was first built for, e.g. Auth.vue) - set this on a dark
        // background (e.g. Lobby.vue) or it'll be near-illegible.
        dark: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
    .team-marquee{
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
        mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
    }

    .team-marquee-track{
        display: flex;
        width: max-content;
        animation: team-marquee-scroll 22s linear infinite;
    }

    .team-marquee-item{
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.8rem;
        color: var(--vc-text-600, #555);
        padding: 0 1rem;
    }

    .team-marquee-dot{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 0.4rem;
        flex-shrink: 0;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }

    .team-marquee-dark .team-marquee-item{
        color: rgba(255, 255, 255, 0.75);
    }
    .team-marquee-dark .team-marquee-dot{
        border-color: rgba(255, 255, 255, 0.3);
    }

    @keyframes team-marquee-scroll{
        from{ transform: translateX(0); }
        to{ transform: translateX(-50%); }
    }
</style>
